import React from "react";

const R0LearningCenterInformation = ({ formData, validationCheck }) => {
  const { learningCenterName, learningCenterCharter, learningCenterAddress } =
    formData;
  return (
    <div className="sub-form site-sub-form">
      <h3>Selected Learning Center</h3>
      <div
        className="sum-item"
        style={{
          borderBottom:
            validationCheck && learningCenterName === ""
              ? "solid 2px #d8302f"
              : "none",
        }}
      >
        <h4>Site:</h4>
        <p>{learningCenterName}</p>
      </div>
      <div
        className="sum-item"
        style={{
          borderBottom:
            validationCheck && learningCenterCharter === ""
              ? "solid 2px #d8302f"
              : "none",
        }}
      >
        <h4>Charter:</h4>
        <p>{learningCenterCharter}</p>
      </div>
      <div
        className="sum-item"
        style={{
          borderBottom:
            validationCheck && learningCenterAddress === ""
              ? "solid 2px #d8302f"
              : "none",
        }}
      >
        <h4>Address:</h4>
        <p>{learningCenterAddress}</p>        
      </div>
      <div
        className="sum-item"
        style={{
          borderBottom:
            validationCheck && formData._uuid === ""
              ? "solid 2px #d8302f"
              : "none",
        }}
      >
        <h4>Registration ID:</h4>
        <p>{formData._uuid}</p>        
      </div>
    </div>
  );
};

export default R0LearningCenterInformation;
